import gql from 'graphql-tag';

export default gql`
  query SearchDiscountPrices($input: SearchDiscountPricesInput!) {
    searchDiscountPrices(input: $input) {
      totalResult
      totalPage
      data {
        price
        vat
        vatIncluded
        startTime
        endTime
        status
        buyer {
          id
          name
        }
      }
    }
  }
`;
